"use strict";

var Group, React, ReactBootstrap, classnames;

React = require("react");

classnames = require("classnames");

ReactBootstrap = require("react-bootstrap");

Group = React.createClass({
  displayName: "Group",

  propTypes: {
    dataKey: React.PropTypes.string.isRequired,
    formDef: React.PropTypes.object.isRequired,
    title: React.PropTypes.string,
    removeNestedForm: React.PropTypes.func
  },
  getInitialState: function getInitialState() {
    var ref, ref1;
    return {
      collapsed: (ref = this.props.formDef.collapsed) != null ? ref : false,
      collapsable: (ref1 = this.props.formDef.collapsable) != null ? ref1 : true
    };
  },
  toggleCollapse: function toggleCollapse(event) {
    return this.setState({
      collapsed: !this.state.collapsed
    });
  },
  removeNestedForm: function removeNestedForm() {
    return this.props.removeNestedForm(this.props.dataKey);
  },
  renderHeader: function renderHeader() {
    var ref;
    if ((ref = this.props.title) != null ? ref : this.props.removeNestedForm != null) {
      return React.createElement(
        "div",
        { className: "panel-heading", onClick: this.state.collapsable ? this.toggleCollapse : "" },
        React.createElement(
          "h3",
          { className: "panel-title" },
          this.renderCollapsedIndicador(),
          " ",
          this.props.title
        ),
        this.renderDeleteButton()
      );
    }
  },
  renderCollapsedIndicador: function renderCollapsedIndicador() {
    if (this.state.collapsable) {
      if (this.state.collapsed) {
        return React.createElement(ReactBootstrap.Glyphicon, { glyph: "chevron-right" });
      } else {
        return React.createElement(ReactBootstrap.Glyphicon, { glyph: "chevron-down" });
      }
    }
  },
  renderDeleteButton: function renderDeleteButton() {
    if (this.props.removeNestedForm != null) {
      return React.createElement(
        "div",
        { className: "pull-right panel-btns" },
        React.createElement(
          ReactBootstrap.Button,
          { onClick: this.removeNestedForm },
          React.createElement(ReactBootstrap.Glyphicon, { glyph: "remove" })
        )
      );
    }
  },
  render: function render() {
    var classes;
    classes = classnames({
      "panel-body": true,
      hidden: this.state.collapsed
    });
    return React.createElement(
      "div",
      { className: "panel panel-visible" },
      this.renderHeader(),
      React.createElement(
        "div",
        { className: classes },
        this.props.children
      )
    );
  }
});

module.exports = Group;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/containers/Group.js
 ** module id = 589
 ** module chunks = 0
 **/